// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tY1-j","content":"styles_content__blT5w"};